// extracted by mini-css-extract-plugin
export var alertIcon = "_tj-0";